import { Controller } from '@hotwired/stimulus'
import Choices from 'choices.js'

export default class extends Controller {
  static targets = ['select']
  static values = {
    searchEnabled: { type: Boolean, default: false },
    removeItemButton: { type: Boolean, default: false },
    placeholder: { type: String, default: '' }
  }

  connect () {
    this.initChoices()
    document.addEventListener('turbo:morph', this.reload.bind(this))
  }

  disconnect () {
    try {
      if (this.choices) {
        this.choices.destroy()
      }
      document.removeEventListener('turbo:morph', this.reload.bind(this))
    } catch { }
  }

  reload () {
    if (this.choices) {
      this.choices.destroy()
      this.initChoices()
    }
  }

  initChoices () {
    this.choices = new Choices(this.selectTarget, {
      allowHTML: true,
      searchEnabled: this.searchEnabledValue,
      searchPlaceholderValue: 'Поиск...',
      searchFloor: 1,
      removeItemButton: this.removeItemButtonValue,
      itemSelectText: '',
      noResultsText: 'Ничего не найдено',
      noChoicesText: 'Нет вариантов для выбора',
      placeholderValue: this.placeholderValue,
      shouldSort: false,
      fuseOptions: {
        threshold: 0.3
      },
      classNames: {
        containerOuter: ['choices', 'form__choices'],
        containerInner: ['choices__inner', 'form__choices-inner'],
        input: ['choices__input', 'form__choices-input'],
        inputCloned: ['choices__input--cloned', 'form__choices-input--cloned'],
        list: ['choices__list'],
        listItems: ['choices__list--multiple'],
        listSingle: ['choices__list--single'],
        listDropdown: ['choices__list--dropdown'],
        item: ['choices__item'],
        itemSelectable: ['choices__item--selectable'],
        itemDisabled: ['choices__item--disabled'],
        itemChoice: ['choices__item--choice'],
        description: ['choices__description'],
        placeholder: ['choices__placeholder'],
        group: ['choices__group'],
        groupHeading: ['choices__heading'],
        button: ['choices__button'],
        activeState: ['is-active'],
        focusState: ['is-focused'],
        openState: ['is-open'],
        disabledState: ['is-disabled'],
        highlightedState: ['is-highlighted'],
        selectedState: ['is-selected'],
        flippedState: ['is-flipped'],
        loadingState: ['is-loading'],
        notice: ['choices__notice'],
        addChoice: ['choices__item--selectable', 'add-choice'],
        noResults: ['has-no-results'],
        noChoices: ['has-no-choices']
      }
    })

    // Сохраняем instance для доступа из других контроллеров
    this.selectTarget.choicesInstance = this.choices

    // Диспатчим событие о готовности для других контроллеров
    this.selectTarget.dispatchEvent(new CustomEvent('choices:ready', {
      bubbles: true,
      detail: { choices: this.choices }
    }))
  }
}
